/** Pathing */
export const ICON_CONTENT = "content.icon";
export const CUSTOM_ICON_CONTENT = "content.customSVG";
export const CUSTOM_ICON = "custom";

/** Filter */
export const ALL_ICONS = "all";

export const BIG_ICONS = ["created-with-showit", "Showit-Logo-and-Wordmark"];
